import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { alpha, styled } from '@mui/material/styles';
import { grey , blue} from '@mui/material/colors';
import { Typography, Grid, Box, Chip, Checkbox, CircularProgress, Link, Divider, Stack, Avatar, TextField, Switch, FormGroup, FormControlLabel, createTheme, ThemeProvider, makeStyles, FormControl, InputLabel, Select, MenuItem, Autocomplete} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';

import { UserCircle as UserCircleIcon } from '../../../icons/user-circle';

import FacebookAdGroupDialogAdsListTable from '../../FacebookAdGroupDialog/FacebookAdGroupDialogAdsListTable';

import CmsContext from '../../../store/cms-context';

import { LoadingButton } from '@mui/lab';
import Languages from '../../../Utilities/Languages';





function FacebookAdGroupDialogGeneric(props) {

  const cmsContext = React.useContext(CmsContext);

  const dropzoneRef = React.useRef(null);



  function handle_close() {

    props.set_facebook_ad_group_dialog_state((previous_state) => {

        const temp_state = {...previous_state};
        temp_state.is_dialog_open = false
        return props.set_facebook_ad_group_dialog_state(temp_state);

    })

  }

  console.log('ad group dialog state was: ', props.facebook_ad_group_dialog_state)

  var is_dialog_open = false;

  if(props.facebook_ad_group_dialog_state.is_dialog_open){

    is_dialog_open = true

  }

  if(props.campaign_dialog_state && props.campaign_dialog_state.is_dialog_open){

    is_dialog_open = false

  }

  if(props.adset_dialog_state && props.adset_dialog_state.is_dialog_open){

    is_dialog_open = false

  }

  return (

      <Dialog
        open={is_dialog_open}
        onClose={handle_close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth={'md'}
      >

        <DialogTitle id="alert-dialog-title">
         Ad Group
        </DialogTitle>

        <DialogContent dividers>


          <Grid
            container
            spacing={3}
            alignItems="center"
            >

              <Grid
              item
              xs={12}
             
              >

                <div style={{display:'flex'}}>

                <Avatar
                    sx={{
                      height: 84,
                      width: 84
                    }}
                    src="/static/images/advertisement.png"
                  >
                    
                    <UserCircleIcon fontSize="small" />

                </Avatar>

              </div>

              </Grid> 

              {!props.facebook_ad_group_dialog_state.is_dialog_loading ? 
              
              <>
              
              <Grid
              item
              xs={12}
              sx={{marginTop:1}}
              >
                
                <TextField fullWidth label="Name" disabled={props.facebook_ad_group_dialog_state.type === "Edit"} value={props.facebook_ad_group_dialog_state.adgroup.name} onChange={(event) => {const temp_state = {...props.facebook_ad_group_dialog_state}; temp_state.adgroup.name = event.target.value; props.set_facebook_ad_group_dialog_state(temp_state);}} variant="outlined" />
                  
              </Grid>
              
              {props.facebook_ad_group_dialog_state.type === "Create" || props.facebook_ad_group_dialog_state.type === "Deploy" ?
                
                <>

                <Grid item xs={12} sx={{marginTop:1}}>
                                
                <FormControl fullWidth >
                <InputLabel id="demo-select-small-label">Account</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  fullWidth
                  value={props.facebook_ad_group_dialog_state.selected_account}
                  label="Account"
                  onChange={(event) => {props.get_facebook_campaigns(event.target.value);props.get_account_pixels(event.target.value);}}
                >
                  {props.facebook_ad_group_dialog_state.accounts.map((item, index)=> (
                  <MenuItem
                  key={index} value={item.id}>{item.name}</MenuItem>
                  ))}
                </Select>
                </FormControl>

                </Grid>

                {props.facebook_ad_group_dialog_state.campaigns.length > 0 ? <Grid item xs={12} sx={{marginTop:1}}>

                <Autocomplete
                    id="selected-campaigns"
                    options={props.facebook_ad_group_dialog_state.campaigns}
                    getOptionLabel={(option) => option.name ? option.name : ""}
                    value={props.facebook_ad_group_dialog_state.selected_campaign}
                    isOptionEqualToValue={(option, value) => {
                      return value.id ? value.id === option.id : false
                    }} 
                    onChange={(event, newValue) => {

                      if(newValue){

                        props.set_facebook_ad_group_dialog_state((previous_state) => {

                            const temp_state = {...previous_state};
                            temp_state.selected_campaign = newValue;
                            return props.set_facebook_ad_group_dialog_state(temp_state);

                        })

                        props.get_adsets(newValue.id)

                      }

                    }}
                    renderOption={(props, option, state) => {
                      //console.log('index was: ', props, " : ", option, " : ", state)
                      const key = `listItem-${option.id}`;
                      return (
                        <li {...props} key={key}>
                          {option.name}
                        </li>
                      );
                      
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Campaigns" placeholder="Campaigns" />
                    )}
                />

                </Grid> : null}

                {props.facebook_ad_group_dialog_state.adsets.length > 0 ? <Grid item xs={12} sx={{marginTop:1}}>

                <Autocomplete
                    id="selected-adsets"
                    options={props.facebook_ad_group_dialog_state.adsets}
                    getOptionLabel={(option) => option.name ? option.name : ""}
                    value={props.facebook_ad_group_dialog_state.selected_adset}
                    isOptionEqualToValue={(option, value) => {
                      return value.id ? value.id === option.id : false
                    }} 
                    onChange={(event, newValue) => {

                      if(newValue) {

                        props.set_facebook_ad_group_dialog_state((previous_state) => {

                        const temp_state = {...previous_state};
                        temp_state.selected_adset = newValue;
                        return props.set_facebook_ad_group_dialog_state(temp_state);

                      })

                      if(props.facebook_ad_group_dialog_state.type === "Create" ){

                       props.get_adset_ads(newValue.id);

                      }

                    }
                      
                    }}
                    renderOption={(props, option, state) => {
                      //console.log('index was: ', props, " : ", option, " : ", state)
                      const key = `listItem-${option.id}`;
                      return (
                        <li {...props} key={key}>
                          {option.name}
                        </li>
                      );
                      
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Adsets" placeholder="Adsets" />
                    )}
                />

                </Grid> : null}


                </> : null}


              {props.facebook_ad_group_dialog_state.type === "Deploy" ?

                <>

              {props.facebook_ad_group_dialog_state.selected_adset && Object.keys(props.facebook_ad_group_dialog_state.selected_adset).length > 0 ?  <Grid item xs={12}>
                <Autocomplete
                  id="target-language"
                  options={Languages}
                  getOptionLabel={(option) => `${option.name}`}
                  value={Languages.find(lang => lang.code === props.facebook_ad_group_dialog_state.target_language) || null}
                  onChange={(event, newValue) => {

                    props.set_facebook_ad_group_dialog_state((previous_state) => {

                        const temp_state = {...previous_state};
                        temp_state.target_language = newValue?.code || '';
                        return props.set_facebook_ad_group_dialog_state(temp_state);

                    })

                  }}
                  isOptionEqualToValue={(option, value) => option.code === value.code}
                  renderOption={(props, option) => (
                    <li {...props} key={option.code}>
                      {option.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} label="Target Language" placeholder="Language" />
                  )}
                />
              </Grid> : null}
                
              {props.facebook_ad_group_dialog_state.all_domains && Object.keys(props.facebook_ad_group_dialog_state.all_domains).length > 0 ?  <Grid item xs={12}>
                <Autocomplete
                  id="target-pixel"
                  options={props.facebook_ad_group_dialog_state.all_domains}
                  getOptionLabel={(option) => `${option.domain}`}
                  value={props.facebook_ad_group_dialog_state.all_domains.find(lang => lang.domain === props.facebook_ad_group_dialog_state.selected_domain) || null}
                  onChange={(event, newValue) => {

                    props.set_facebook_ad_group_dialog_state((previous_state) => {

                        const temp_state = {...previous_state};
                        temp_state.selected_domain = newValue?.domain || ''
                        return props.set_facebook_ad_group_dialog_state(temp_state);

                    })

                  }}
                  isOptionEqualToValue={(option, value) => option.domain === value.domain}
                  renderOption={(props, option) => (
                    <li {...props} key={option.domain}>
                      {option.domain}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} label="Target Domain" placeholder="Domain" />
                  )}
                />
              </Grid> : null}
      
              {props.facebook_ad_group_dialog_state.all_target_account_pixels && Object.keys(props.facebook_ad_group_dialog_state.all_target_account_pixels).length > 0 ?  <Grid item xs={12}>
                <Autocomplete
                  id="target-pixel"
                  options={props.facebook_ad_group_dialog_state.all_target_account_pixels}
                  getOptionLabel={(option) => `${option.name}`}
                  value={props.facebook_ad_group_dialog_state.all_target_account_pixels.find(lang => lang.id === props.facebook_ad_group_dialog_state.selected_target_account_pixel) || null}
                  onChange={(event, newValue) => {

                    props.set_facebook_ad_group_dialog_state((previous_state) => {

                        const temp_state = {...previous_state};
                        temp_state.selected_target_account_pixel = newValue?.id || '';
                        return props.set_facebook_ad_group_dialog_state(temp_state);

                    })

                  }}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} label="Target Pixel" placeholder="Pixel" />
                  )}
                />
              </Grid> : null}


                </> : null}


              <Grid item xs={12}>

              <FacebookAdGroupDialogAdsListTable facebook_ad_group_dialog_state={props.facebook_ad_group_dialog_state} set_facebook_ad_group_dialog_state={props.set_facebook_ad_group_dialog_state}></FacebookAdGroupDialogAdsListTable>
        
              </Grid>

              </> : <Grid item xs={12}><div style={{textAlign:'center', margin:60}}> <CircularProgress /> </div></Grid>} 

            
            </Grid>

        </DialogContent>
        <DialogActions>
        {props.facebook_ad_group_dialog_state.type && props.facebook_ad_group_dialog_state.type.length > 0 ? <Button disabled={props.facebook_ad_group_dialog_state.is_dialog_loading} onClick={() => {props.post_ad_group(props.facebook_ad_group_dialog_state, props.all_facebook_breakdowns, props.facebook_ad_group_dialog_state)}} variant='outlined'>{props.facebook_ad_group_dialog_state.type}</Button> : null}
        {props.facebook_ad_group_dialog_state.selected_account.length > 0 ? <Button disabled={props.facebook_ad_group_dialog_state.is_dialog_loading} onClick={() => {props.show_campaign_dialog("Create")}} variant='outlined'>Create Campaign</Button> : null}
        {Object.keys(props.facebook_ad_group_dialog_state.selected_campaign).length > 0 ? <Button disabled={props.facebook_ad_group_dialog_state.is_dialog_loading} onClick={() => {props.show_adset_dialog("Create")}} variant='outlined'>Create AdSet</Button> : null}
        <Button onClick={handle_close} variant='outlined'>{"Close"}</Button>
        </DialogActions>
      </Dialog>

  );

}

export default React.memo(FacebookAdGroupDialogGeneric);